// export const phoneRegExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
export const phoneRegExp = /^(?=.*[0-9])[- +()0-9]+$/im;
export const SITE_KEY = '6LenRkYaAAAAAJf7P8OamoQSU7H5YaAKpMqTkGzU';